module.exports = __webpack_public_path__ + "img/selected5-min.accb0003.png";